import { useEffect, useState } from "react";
import { Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import {
  HeaderBar,
  HeaderSection,
  LogoContainer,
  LogoImage,
  Burger,
  NotHidden,
  Menu,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);
  const isMobileScreen = () => window.innerWidth <= 768;
  const [isMobile, setIsMobile] = useState(isMobileScreen());

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileScreen());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    return (
      <nav aria-label="Primary navigation">
        <CustomNavLinkSmall>
          <a href="/about">{t("About")}</a>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <a href="/services">{t("Services")}</a>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <a href="/technology">{t("Technology")}</a>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <a href="/products">{t("Products")}</a>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall>
          <a href="/case-studies">{t("Case Studies")}</a>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => {
          setVisibility(false);
          window.location.href = "/contact";
        }}>
          <Span>
            <Button>{t("Contact")}</Button>
          </Span>
        </CustomNavLinkSmall>
      </nav>
    );
  };

  return (
    <HeaderSection>
      <Container>
        <HeaderBar>
          <LogoContainer to="/" aria-label="Ashur Soft homepage">
            <LogoImage src="/img/svg/logo.svg" alt="Ashur Soft" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          {isMobile && (
            <Burger onClick={toggleButton} aria-label="Open menu">
              <Outline />
            </Burger>
          )}
        </HeaderBar>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              <Col span={12}>
                <Menu>Menu</Menu>
              </Col>
              <Col span={12}>
                <Outline />
              </Col>
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
